import { TEXT_LINK_FOCUS_RING } from "../lib/a11yFocus";
import { useEffect, useState } from "react";
import { generatePath, Link } from "react-router-dom";
import { Button } from "../components/BaseComponents";
import PageHeadings from "../components/BaseComponents/PageHeadings/PageHeadings";
import PageTemplate from "../components/BaseComponents/PageTemplate/PageTemplate";
import SimpleSortTable, { TableColumn } from "../components/BaseComponents/SimpleSortTable/SimpleSortTable";
import routes from "../components/Router/routes";
import useApi from "../hooks/useApi";
import { formatControlRequestStatus, formatDate } from "../lib/utils";
import { formatDelegatedAccessLevel } from "../lib/delegatedAccess";

function ClientCompanies() {

    const [loading, setLoading] = useState(true);
    const api = useApi();
    const [data, setData] = useState<any[]>([])

    useEffect(() => {
        setLoading(true);
        const run = async () =>{ 
            const result = await api.get('/delegatedAccess/mine?limit=100')
            setData(result.data.map((grant: any) => ({ ...grant, _id: grant.id })))
            setLoading(false);
        }

        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns: TableColumn[] = [
        {
            id: 'grantorCompanyName',
            label: 'Organisation name',
            renderer: (key, data) => {
                const controlPath = generatePath(
                    routes.assumeOrganisation.path,
                    {assumptionType: 'delegated', companyId: data.grantorCompanyId}
                );
                
                const hasAccess = data.status === 'active'
                return hasAccess ? (
                    <Link
                        className={`underline text-algae-500 ${TEXT_LINK_FOCUS_RING}`}
                        to={controlPath}
                    >
                        { data.grantorCompanyName }
                    </Link>
                ) : (
                    <span>{ data.grantorCompanyName }</span>
                );
            }
        },
        {
            id: 'grantorCompanyNumber',
            label: 'Registered #'
        },
        {
            id: 'status',
            label: 'Status',
            renderer: (key, data) => <span>{ formatControlRequestStatus(data[key]) }</span>
        },
        {
            id: 'accessLevel',
            label: 'Access level',
            renderer: (key, data) => <span>{ data.status === 'active' ? formatDelegatedAccessLevel(data[key]) : '' }</span>
        },
        {
            id: 'grantorJurisdiction',
            label: 'Jurisdiction',
        },
        {
            id: 'grantorAddress',
            label: 'Address',
        },
        {
            id: 'grantorLatestReport',
            label: 'Latest Report',
            renderer: (key, data) =>{ 
                const value = data[key];
                return <span>{ value ? formatDate(data[key]) : null }</span>
            }
        },
    ]

    return (
        <PageTemplate>
            <PageHeadings title="Client Organisations"/>
            <div className="mt-8">
                <Button
                    requiresWrite
                    type="Primary"
                    text="Invite organisation"
                    hasLeadingIcon
                    icon="fa-solid fa-user-plus"
                    size="sm"
                    isLink
                    url={routes.publicProfiles.path}
                />
            </div>
            <SimpleSortTable
                additionalClass="mt-8"
                data={data}
                columns={columns}
                isLoading={loading}
            />
        </PageTemplate>
    )
}

export default ClientCompanies;